import React from 'react';
export default function ChickenHatSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Chicken body */}
      <ellipse cx="20" cy="26" rx="12" ry="10" fill="#F5F5F0" />
      {/* Belly shading */}
      <ellipse cx="20" cy="28" rx="9" ry="7" fill="#EFEBE9" />

      {/* Tail feathers */}
      <path d="M30 22 L36 16 L34 22 L38 18 L34 24 L36 22 L32 26" fill="#E0E0E0" />

      {/* Wing */}
      <ellipse cx="14" cy="26" rx="5" ry="4" fill="#E0E0E0" />
      <ellipse cx="26" cy="26" rx="5" ry="4" fill="#E0E0E0" />

      {/* Head */}
      <circle cx="20" cy="14" r="7" fill="#F5F5F0" />

      {/* Red comb */}
      <path d="M16 8 C16 4 18 3 19 5 C19 3 21 3 21 5 C21 3 23 4 24 8 Z" fill="#E53935" />

      {/* Wattle */}
      <path d="M19 20 C18 22 20 23 21 20" fill="#E53935" />

      {/* Beak */}
      <polygon points="17,16 20,18 23,16" fill="#FF8F00" />
      <polygon points="18,16 20,17 22,16" fill="#FFB300" />

      {/* Eyes */}
      <circle cx="17" cy="13" r="1.5" fill="#3E2723" />
      <circle cx="23" cy="13" r="1.5" fill="#3E2723" />
      <circle cx="16.6" cy="12.6" r="0.5" fill="white" />
      <circle cx="22.6" cy="12.6" r="0.5" fill="white" />

      {/* Feet draped over edge */}
      <path d="M14 35 L12 38 L10 37 L12 38 L14 37 L12 38 L14 38" stroke="#FF8F00" strokeWidth="1.2" fill="none" strokeLinecap="round" />
      <path d="M26 35 L28 38 L30 37 L28 38 L26 37 L28 38 L26 38" stroke="#FF8F00" strokeWidth="1.2" fill="none" strokeLinecap="round" />
    </svg>
  );
}
